import { type InsightsClient } from 'instantsearch.js/es/types/insights';
import aa from 'search-insights';

import { cookies } from '@/utils/cookies';

import { API_KEY, APP_ID } from '../search-client';

const USER_ID = cookies.client.get('user_id')?.value;

if (USER_ID) {
  aa('init', {
    appId: APP_ID,
    apiKey: API_KEY,
    userToken: USER_ID,
  });
} else {
  aa('init', {
    appId: APP_ID,
    apiKey: API_KEY,
    useCookie: true,
  });
}

const insightsConfig = {
  insightsClient: aa as InsightsClient,
};

export default insightsConfig;
